import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { fetchJSON, apiRootEndpoint } from '../../helpers';
import {
    GET_USERS, 
    SUBMIT_USER_FORM,
    DELETE_USER
} from '../../constants/actionTypes';


import {
    getAllUsersSuccess,
    getAllUsersFailed,

    submitUserFormSuccess,
    submitUserFormFailed,

    deleteUserSuccess,
    deleteUserFailed,
} from './actions';

const apiUrl = `${apiRootEndpoint}/api/v1/portal/users`;

function* getAllUsers({ payload: { offset, limit } }) {
    const options = {
        method: 'GET',
    };

    try {
        const url = `${apiUrl}?offset=${offset}&limit=${limit}`;
        const {total, data} = yield call(fetchJSON, url, options);
        yield put(getAllUsersSuccess({total, data}));
    } catch (error) {
        let message;
        switch (error.status) {
            case 500: message = 'Internal Server Error'; break;
            default: message = error;
        }
        yield put(getAllUsersFailed(message));
    }
}

function* submitUser({ payload: user }) {
    const options = {
        body: JSON.stringify(user),
        method: user.id ? 'PUT' :  'POST',
        headers: { 'Content-Type': 'application/json' }
    };

    try {
        let url = `${apiUrl}`;
        if(user.id) {
            url = `${apiUrl}/${user.id}`;
        }
        const response = yield call(fetchJSON, url, options);
        if(response.status === 'OK') {
            yield put(submitUserFormSuccess(response.data));
        }
        else {
            yield put(submitUserFormFailed(response.message));
        }
    } catch (error) {
        let message;
        switch (error.status) {
            case 500: message = 'Internal Server Error'; break;
            default: message = error;
        }
        yield put(submitUserFormFailed(message));
    }
}

function* deleteUser({ payload: id }) {
    const options = {
        method: 'DELETE',
    };
    try {
        const url = `${apiUrl}/${id}`;
        const response = yield call(fetchJSON, url, options);
        if(response.status === 'OK') {
            yield put(deleteUserSuccess(id));
        }
        else {
            yield put(deleteUserFailed(response.message));
        }
    } catch (error) {
        let message;
        switch (error.status) {
            case 500: message = 'Internal Server Error'; break;
            default: message = error;
        }
        yield put(deleteUserFailed(message));
    }
}


export function* watchGetAllUsers() {
    yield takeEvery(GET_USERS, getAllUsers);
}
export function* watchSubmitUserForm() {
    yield takeEvery(SUBMIT_USER_FORM, submitUser);
}
export function* watchDeleteUser() {
    yield takeEvery(DELETE_USER, deleteUser);
}

function* userSaga() {
    yield all([
        fork(watchGetAllUsers),
        fork(watchSubmitUserForm),
        fork(watchDeleteUser),
    ]);
}

export default userSaga;